module.exports = __webpack_public_path__ + "assets/61ac3bd3c7748c6bcec01048469a2bff.gif";